import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Products from "@/components/Products";
import Tips from "@/components/Tips";
import VideoSection from "@/components/VideoSection";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import CtaBanner from "@/components/CtaBanner";
import Footer from "@/components/Footer";
import WhatsAppWidget from "@/components/WhatsAppWidget";

function App() {
  return (
    <div className="App font-sans text-[#0f1733] antialiased">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Tips />
        <VideoSection />
        <Contact />
        <FAQ />
        <About />
        <CtaBanner />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

export default App;
